/**
 * @ngInject
 */

function DataService($q, $http) {
    var api = {};
    
    function sendRequest(data) {
        var request = $q.defer();

        $http({
            method : 'POST',
            url : ajaxUrl,
            data : jQuery.param(data),
            headers : {'Content-Type': 'application/x-www-form-urlencoded'} // Tradional $_POST array - not php input stream

        }).then(function (response) {

            if (angular.isDefined(response.config)) {
                if (angular.isDefined(response.config.data)) {
                    console.log(response.config.data.action + "::success", response);
                }
            }

            if (response.data.status === 1) {
                // SUCCESS
                request.resolve(response.data);
            }
            else {
                // PARAM ERROR
                request.reject(response);
            }

        }, function (response) {
            
            // SYSTEM ERROR
            request.reject(response);
        });

        return request.promise;
    }

    // api.saveData = function(formData) {
    //     console.log(formData);
    //     return sendRequest({
    //         action : 'saveData',
    //         message : formData.message
    //     });
    // }

    api.getArchive = function(postType, pageSize) {
        // console.log(formData);
        return sendRequest({
            action : 'archive',
            post_type : postType,
            page_size : pageSize
        });
    }

    api.newsletterSignup = function(email, groupId) {
        // console.log(formData);
        return sendRequest({
            action : 'newsletter',
            email : email,
            id : groupId,
        });
    }


    return api;
}